import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "contributions-table-item" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h4", null, " Coverage History", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", null, "This screen displays a record of your current and past enrollment", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, "Coverage Type"),
    /*#__PURE__*/_createElementVNode("th", null, "Carrier Code"),
    /*#__PURE__*/_createElementVNode("th", null, "Effective Date"),
    /*#__PURE__*/_createElementVNode("th", null, "Term/Susp"),
    /*#__PURE__*/_createElementVNode("th", null, "Reason")
  ])
], -1)
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { key: 1 }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("td", { colspan: "8" }, "No coverage history found")
], -1)
const _hoisted_8 = [
  _hoisted_7
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _createElementVNode("table", null, [
      _hoisted_4,
      (_ctx.coverageHistory.length > 0)
        ? (_openBlock(), _createElementBlock("tbody", _hoisted_5, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.coverageHistory, (coverage) => {
              return (_openBlock(), _createElementBlock("tr", {
                key: coverage.CoverageID
              }, [
                _createElementVNode("td", null, _toDisplayString(coverage.FundName || 'N/A'), 1),
                _createElementVNode("td", null, _toDisplayString(coverage.CarrierCode || 'N/A'), 1),
                _createElementVNode("td", null, _toDisplayString(coverage.EffectiveDate), 1),
                _createElementVNode("td", null, _toDisplayString(coverage.TerminationDate), 1)
              ]))
            }), 128))
          ]))
        : (_openBlock(), _createElementBlock("tbody", _hoisted_6, _hoisted_8))
    ])
  ]))
}